import { ColDef } from '@ag-grid-community/core'

export const GFRDefaultFactorContributionTableColumns: ColDef[] = [
  {
    field: 'factor_sub_category',
    rowGroup: true,
    hide: true,
  },
  {
    field: 'factor_name',
  },
  {
    field: 'portfolio_total_return',
    headerName: 'Portfolio Factor Contribution (bps)',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = parseFloat(params.value)
      if (isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
  {
    field: 'benchmark_total_return',
    headerName: 'Benchmark Factor Contribution (bps)',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = parseFloat(params.value)
      if (isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
  {
    field: 'active_total_return',
    headerName: 'Active Factor Contribution (bps)',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined) return ''
      const num = parseFloat(params.value)
      if (isNaN(num)) return params.value
      return num.toFixed(3)
    },
  },
]

export const GFRFactorContributionTableColumnsWithCurrency = [
  {
    field: 'currency_code',
    rowGroup: true,
    hide: true,
  },
  ...GFRDefaultFactorContributionTableColumns,
]
